const localState = {
    list: null,
    skill: {
        name: '',
    },
}

const mutations = {
    setState: (state, {
        key,
        data,
    }) => {
        state[key] = data
    },
}

const actions = {
    async fetch({
        commit,
    }) {
        const response = await this.$api.skills.fetch()

        commit('setState', {
            key: 'list',
            data: response.data.data || [],
        })
    },
    async add({
        state,
    }) {
        return await this.$api.skills.add(state.skill)
    },
    async update({ state }, id) {
        return await this.$api.skills.update(id, state.skill)
    },
    async remove(_, id) {
        return await this.$api.skills.remove(id)
    },
}
const getters = {
    list: (state) => state.list,
    skill: (state) => state.skill,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
